// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".PaperImages-cls1___9ee2a249647137b92f8{/*!*/}.PaperImages-cls2__f75bad42708d9acac758{-o-object-fit:contain;object-fit:contain;max-height:100%;max-width:100%;cursor:pointer}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "PaperImages-cls1___9ee2a249647137b92f8",
	"cls2": "PaperImages-cls2__f75bad42708d9acac758 PaperImages-cls1___9ee2a249647137b92f8"
};
export default ___CSS_LOADER_EXPORT___;
